import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, useHistory } from "react-router-dom";
import classnames from "classnames";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ButtonGroup,
  UncontrolledDropdown,
} from "reactstrap";

import { BreadCrumb } from "../../components/Common";
import { AcademicCalendarPage } from "./AcademicCalendarPage";
import { AppVersionPage } from "./AppVersionPage";
import { HomeWorkAlertPage } from "./HomeWorkAlertPage";
import { ExamNoticePage } from "./ExamNoticePage";
import { TermsOfServicePage } from "./TermsServicePage";
import { PrivacyPolicyPage } from "./PrivacyPolicyPage";
import { SupplicationsPage } from "./SupplicationsPage";
import { BannersPage } from "./BannersPage";
import {
  AllSubjectBenefitsPage,
  AllSubjectChargeablePricePage,
  AllSubjectDisplayPricePage,
  OlympicMessagePage,
  OneSubjectBenefitsPage,
  OneSubjectChargeablePricePage,
  OneSubjectDisplayPricePage,
} from "../";

type TProps = RouteComponentProps & {};

export const ControlAppTabsPage: React.FC<TProps> = () => {
  //#region hooks
  const { t } = useTranslation();
  const history = useHistory();
  //#endregion

  //#region internal state
  const [activeTab, setActiveTab] = useState(history.location.hash || "1");
  //#endregion

  //#region effects
  useEffect(() => {
    const hash = history.location.hash;
    if (hash) {
      switch (hash) {
        case "#slide-show":
          setActiveTab("1");
          break;
        case "#application-version":
          setActiveTab("2");
          break;
        case "#privacy-policy":
          setActiveTab("3");
          break;
        case "#terms-of-service":
          setActiveTab("4");
          break;
        case "#academic-calendar":
          setActiveTab("5");
          break;
        case "#study-supplication":
          setActiveTab("6");
          break;
        case "#exam-notice":
          setActiveTab("7");
          break;
        case "#olympic":
          setActiveTab("8");
          break;
        case "#homework-alert":
          setActiveTab("9");
          break;
        case "#one-subject-benefits":
          setActiveTab("10");
          break;
        case "#one-subject-display-price":
          setActiveTab("11");
          break;
        case "#one-subject-chargeable-price":
          setActiveTab("12");
          break;
        case "#all-subject-benefits":
          setActiveTab("13");
          break;
        case "#all-subject-display-price":
          setActiveTab("14");
          break;
        case "#all-subject-chargeable-price":
          setActiveTab("15");
          break;
        default:
          setActiveTab("1");
          break;
      }
    }
  }, []);

  //#endregion

  //#region handlers
  const pillsToggle = (changingTab: any) => {
    if (activeTab !== changingTab) {
      setActiveTab(changingTab);
    }
  };
  //#endregion

  useEffect(() => {
    console.log("activeTab ", activeTab);
  }, [activeTab]);

  document.title = `${t("documentTitle", { pageName: "controlApp" })}`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("controlApp")} pageTitle={t("")} />
          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <Nav pills className="nav-success">
                    <NavItem>
                      <NavLink
                        href="#slide-show"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "1" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("1");
                        }}
                      >
                        <i className="ri-gallery-line fs-14"></i>&nbsp;
                        {t("slideShow")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#application-version"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "2" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("2");
                        }}
                      >
                        <i className="ri-smartphone-line fs-14"></i>&nbsp;
                        {t("applicationVersion")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#privacy-policy"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "3" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("3");
                        }}
                      >
                        <i className="ri-file-shield-line fs-14"></i>
                        &nbsp;
                        {t("privacyPolicy")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#terms-of-service"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "4" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("4");
                        }}
                      >
                        <i className="ri-file-list-line fs-14"></i>&nbsp;
                        {t("termsOfService")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#academic-calendar"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "5" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("5");
                        }}
                      >
                        <i className="ri-calendar-line fs-14"></i>&nbsp;
                        {t("academicCalendar")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#study-supplication"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "6" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("6");
                        }}
                      >
                        <i className="ri-book-open-line fs-14"></i>&nbsp;
                        {t("studySupplications")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#exam-notice"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "7" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("7");
                        }}
                      >
                        <i className="ri-article-line fs-14"></i>&nbsp;
                        {t("examNotice")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#olympic"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "8" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("8");
                        }}
                      >
                        <i className="ri-award-line fs-14"></i>&nbsp;
                        {t("olympic")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#homework-alert"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "9" },
                          "d-flex"
                        )}
                        onClick={() => {
                          pillsToggle("9");
                        }}
                      >
                        <i className="ri-file-list-line"></i>&nbsp;
                        {t("homeworkAlert")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <ButtonGroup>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="button"
                            className={`btn ${
                              Number(activeTab) >= 10 && Number(activeTab) <= 15
                                ? "btn-primary"
                                : "btn-default"
                            }`}
                            style={{ fontWeight: 500 }}
                          >
                            {t("pricing")}
                            <i className="mdi mdi-chevron-down"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdownmenu-primary">
                            <div
                              className="dropdown-header noti-title text-align-justify"
                              style={{ textAlign: "justify" }}
                            >
                              <h6 className="font-size-13 text-muted text-truncate mb-0">
                                {t("oneSubject")}
                              </h6>
                            </div>
                            <DropdownItem
                              href="#one-subject-benefits"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "10" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("10");
                              }}
                            >
                              {t("benefits")}
                            </DropdownItem>
                            <DropdownItem
                              href="#one-subject-display-price"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "11" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("11");
                              }}
                            >
                              {t("displayPrice")}
                            </DropdownItem>
                            <DropdownItem
                              href="#one-subject-chargeable-price"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "12" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("12");
                              }}
                            >
                              {t("chargeablePrice")} ({t("myFatoorah")})
                            </DropdownItem>
                            <DropdownItem divider />
                            <div
                              className="dropdown-header noti-title"
                              style={{ textAlign: "justify" }}
                            >
                              <h6 className="font-size-13 text-muted text-truncate mb-0">
                                {t("allSubjects")}
                              </h6>
                            </div>
                            <DropdownItem
                              href="#all-subject-benefits"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "13" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("13");
                              }}
                            >
                              {t("benefits")}
                            </DropdownItem>
                            <DropdownItem
                              href="#all-subject-display-price"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "14" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("14");
                              }}
                            >
                              {t("displayPrice")}
                            </DropdownItem>
                            <DropdownItem
                              href="#all-subject-chargeable-price"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                { active: activeTab === "15" },
                                "d-flex"
                              )}
                              onClick={() => {
                                pillsToggle("15");
                              }}
                            >
                              {t("chargeablePrice")} ({t("myFatoorah")})
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </ButtonGroup>
                    </NavItem>
                  </Nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" id="slide-show">
              {activeTab === "1" && <BannersPage />}
            </TabPane>
            <TabPane tabId="2" id="application-version">
              {activeTab === "2" && <AppVersionPage />}
            </TabPane>
            <TabPane tabId="3" id="privacy-policy">
              {activeTab === "3" && <PrivacyPolicyPage />}
            </TabPane>
            <TabPane tabId="4" id="terms-of-service">
              {activeTab === "4" && <TermsOfServicePage />}
            </TabPane>
            <TabPane tabId="5" id="academic-calendar">
              {activeTab === "5" && <AcademicCalendarPage />}
            </TabPane>
            <TabPane tabId="6" id="study-supplications">
              {activeTab === "6" && <SupplicationsPage />}
            </TabPane>
            <TabPane tabId="7" id="exam-notice">
              {activeTab === "7" && <ExamNoticePage />}
            </TabPane>
            <TabPane tabId="8" id="olympic">
              {activeTab === "8" && <OlympicMessagePage />}
            </TabPane>
            <TabPane tabId="9" id="homework-alert">
              {activeTab === "9" && <HomeWorkAlertPage />}
            </TabPane>

            {/* #region one subject*/}
            <TabPane tabId="10" id="one-subject-benefits">
              {activeTab === "10" && <OneSubjectBenefitsPage />}
            </TabPane>
            <TabPane tabId="11" id="one-subject-display-price">
              {activeTab === "11" && <OneSubjectDisplayPricePage />}
            </TabPane>
            <TabPane tabId="12" id="one-subject-chargeable-price">
              {activeTab === "12" && <OneSubjectChargeablePricePage />}
            </TabPane>
            {/* #endregion */}

            {/* #region all subject*/}
            <TabPane tabId="13" id="all-subject-benefits">
              {activeTab === "13" && <AllSubjectBenefitsPage />}
            </TabPane>
            <TabPane tabId="14" id="all-subject-display-price">
              {activeTab === "14" && <AllSubjectDisplayPricePage />}
            </TabPane>
            <TabPane tabId="15" id="all-subject-chargeable-price">
              {activeTab === "15" && <AllSubjectChargeablePricePage />}
            </TabPane>
            {/* #endregion */}
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};
